import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/ComponenteError`

export function BuscarTodos(tipo, idAviso) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${tipo}/${idAviso}`)
}
